import { render } from "./HomePage.vue?vue&type=template&id=c69c2680&scoped=true"
const script = {}

import "./HomePage.vue?vue&type=style&index=0&id=c69c2680&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c69c2680"]])

export default __exports__